/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_passkey_registered_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A passkey was added to your account on this device.`)
};

const zh_hans1_login_passkey_registered_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已在此设备上为您的账户添加了一个通行密钥。`)
};

const zh_hant1_login_passkey_registered_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已在此裝置上為您的帳戶新增一個通行金鑰。`)
};

const fr_login_passkey_registered_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une passkey a été ajoutée à votre compte sur cet appareil.`)
};

const de_login_passkey_registered_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf diesem Gerät wurde ein Passkey zu deinem Konto hinzugefügt.`)
};

const ja_login_passkey_registered_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この端末のアカウントにパスキーが追加されました。`)
};

const ko_login_passkey_registered_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 기기의 계정에 패스키가 추가되었습니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_passkey_registered_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_passkey_registered_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_passkey_registered_desc", locale)
	if (locale === "en") return en_login_passkey_registered_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_passkey_registered_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_passkey_registered_desc(inputs)
	if (locale === "fr") return fr_login_passkey_registered_desc(inputs)
	if (locale === "de") return de_login_passkey_registered_desc(inputs)
	if (locale === "ja") return ja_login_passkey_registered_desc(inputs)
	return ko_login_passkey_registered_desc(inputs)
};